import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/HomeView.vue'),
        meta: {
            title: 'KernelPilot - Parallel Code Generation & Optimization'
        }
    },
    {
        path: '/blog',
        name: 'Blog',
        component: () => import('../views/VersionsView.vue'),
        meta: {
            title: 'Blog - Kernel Pilot'
        }
    },
    {
        path: '/generation',
        name: 'Generation',
        component: () => import('../views/GenerationView.vue'),
        meta: {
            title: 'Generation - KernelPilot'
        }
    },
    {
        path: '/optimization',
        name: 'Optimization',
        component: () => import('../views/OptimizationView.vue'),
        meta: {
            title: 'Optimization - KernelPilot'
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFoundView.vue'),
        meta: {
            title: '404 - Page Not Found'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, _from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        }
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0, behavior: 'smooth' }
    }
})

// Update document title on route change
router.beforeEach((to, _from, next) => {
    const title = to.meta.title as string
    if (title) {
        document.title = title
    }
    next()
})

export default router
